import React, {useEffect, useState} from 'react'
import { formatNumber } from '../../../../utils/tools'
import { InputContainer, ErrorSpan } from '../../DepositElements'
import { selectCurrency, selectUser} from "../../../../features/user/userSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const DatosTransferenciaVnzla = ({form, setForm, handleChange}) => {
  const moneda = useSelector(selectCurrency);
  const user = useSelector(selectUser);
  const [t] = useTranslation("global");
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);


  console.log(user);
  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };


  useEffect(()=>{
    setForm({...form, bancoNombre:'', tipoCuenta:'', numeroCuenta:'', nombreApellido:'', cedula:'', monto2:''})
  },[])
  return (
    <div>
      <InputContainer>
        <label>NOMBRE DEL BANCO</label>
        <input type='text' name='bancoNombre' placeholder='NOMBRE DEL BANCO' value={form.bancoNombre} onChange={handleChange} />
      </InputContainer>
      <InputContainer>
      <label>TIPO DE CUENTA</label>
        <select value={form.tipoCuenta} name='tipoCuenta' onChange={handleChange}>
          <option value=''>SELECCIONE EL TIPO DE CUENTA</option>
          <option value='ahorro'>Ahorro</option>
          <option value='corriente'>Corriente</option>
        </select>
      </InputContainer>
      <InputContainer>
        <label>CTA. NÚMERO:</label>
        <input type='text' name='numeroCuenta' placeholder='NÚMERO DE CUENTA' value={form.numeroCuenta} onChange={handleChange} />
      </InputContainer>
      <InputContainer>
        <label>NOMBRES Y APELLIDOS:</label>
        <input type='text' name='nombreApellido' placeholder='NOMBRES Y APELLIDOS' value={form.nombreApellido} onChange={handleChange} />
      </InputContainer>
      <InputContainer>
        <label>CÉDULA DE IDENTIDAD:</label>
        <input type='text' name='cedula' placeholder='CÉDULA DE IDENTIDAD' value={form.cedula} onChange={handleChange} />
      </InputContainer>
      <InputContainer>
        <label>MONTO:</label>
        <input type='text' name='monto2' placeholder='0,00' value={form.monto2} onChange={(e) => handleMonto(e)} />
        {monto < 40000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than-mibancoDirecta")} 40.000 VES, {t("deposit.amount-less-than-mibancoDirecta2")}{" "}
          </ErrorSpan>
        )}
      </InputContainer>
    </div>
  )
}

export default DatosTransferenciaVnzla